import React, { useEffect, useState } from "react";
import {
  Container,
  MenuItem,
  Select,
  Button,
  FormControl,
  InputLabel,
  TextField,
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Chip,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { saveAs } from "file-saver";
import BASE_URL from "../config";
import { footerConfigs } from "../components/footerConfigs";
const FeeReportPage = () => {
  // =========================================================
  // EXISTING REPORT STATES
  // =========================================================
  const [reportType, setReportType] = useState("");
  const [courses, setCourses] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // =========================================================
  // FEE PAID REPORT STATES
  // =========================================================
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState("");
  const [feePaidStudents, setFeePaidStudents] = useState([]);
  const [feePaidLoading, setFeePaidLoading] = useState(false);
  const [feePaidSearch, setFeePaidSearch] = useState("");
  const [feePaidPage, setFeePaidPage] = useState(0);
  const [feePaidRowsPerPage, setFeePaidRowsPerPage] = useState(100);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentHistory, setStudentHistory] = useState([]);
  const [studentHistoryLoading, setStudentHistoryLoading] =
    useState(false);
  const [historyDialogOpen, setHistoryDialogOpen] =
    useState(false);
  // FOOTER CONFIG
  const footerConfig = footerConfigs["bheema"];
  // =========================================================
  // LOAD COURSES
  // =========================================================
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/coursesss`)
      .then((res) => {
        setCourses(res.data || []);
      })
      .catch((err) => {
        console.error(
          "Error fetching courses:",
          err
        );
      });

  }, []);
  // LOAD CATEGORIES
  useEffect(() => {
    if (
      reportType === "CategoryWise" &&
      selectedCourse
    ) {
      axios
        .get(
          `${BASE_URL}/api/categories?course=${selectedCourse}`
        )
        .then((res) => {
          setCategories(res.data || []);
        })
        .catch((err) => {
          console.error(
            "Error fetching categories:",
            err
          );
        });

    }
  }, [
    reportType,
    selectedCourse
  ]);
  // COURSE CHANGE
  const handleCourseChange = async (courseId) => {
    setSelectedCourse(courseId);
    setSelectedYear("");
    setSelectedClass("");
    setSelectedSection("");
    setAcademicYears([]);
    setClasses([]);
    setSections([]);
    setFeePaidStudents([]);
    if (!courseId) {
      return;
    }
    try {
      const yearRes = await axios.get(
        `${BASE_URL}/api/academic-yearsss?course=${courseId}`
      );
      setAcademicYears(
        yearRes.data || []
      );
      /*
       * Load classes for all reports which need class.
       */
      if (
        reportType === "ByClass" ||
        reportType === "CategoryWise" ||
        reportType === "FeeBetweenDate" ||
        reportType === "ConcessionReport" ||
        reportType === "FeePaid"
      ) {
        const classRes =
          await axios.get(
            `${BASE_URL}/api/classes?course=${courseId}`
          );
        setClasses(
          classRes.data || []
        );
      }
    } catch (error) {
      console.error(
        "Error loading course dependent data:",
        error
      );
    }
  };
  // REPORT TYPE CHANGE
  const handleReportTypeChange = async (value) => {
    setReportType(value);
    // Clear FeePaid states
    setSelectedYear("");
    setSelectedClass("");
    setSelectedSection("");
    setSections([]);
    setFeePaidStudents([]);
    setFeePaidSearch("");
    setFeePaidPage(0);
    if (!selectedCourse) {
      return;
    }
    /*
     * FeePaid needs classes.
     */
    if (value === "FeePaid") {
      try {
        const yearRes =
          await axios.get(
            `${BASE_URL}/api/academic-yearsss?course=${selectedCourse}`
          );
        setAcademicYears(
          yearRes.data || []
        );
        const classRes =
          await axios.get(
            `${BASE_URL}/api/classes?course=${selectedCourse}`
          );
        setClasses(
          classRes.data || []
        );
      } catch (error) {
        console.error(
          "Error loading FeePaid data:",
          error
        );
      }
    }
  };
  // CLASS CHANGE
  const handleClassChange = async (classId) => {
    setSelectedClass(classId);
    setSelectedSection("");
    setSections([]);
    if (!classId) {
      return;
    }
    /*
     * This endpoint returns [] if the class has no sections.
     */
    try {
      const response =
        await axios.get(
          `${BASE_URL}/api/sections?classID=${classId}`
        );
      setSections(
        response.data || []
      );
    } catch (error) {
      console.error(
        "Error loading sections:",
        error
      );
      setSections([]);
    }
  };
  // LOAD FEE PAID REPORT
  useEffect(() => {
    if (
      reportType !== "FeePaid"
    ) {
      return;
    }
    if (
      !selectedCourse ||
      !selectedYear ||
      !selectedClass
    ) {
      setFeePaidStudents([]);
      return;
    }
    loadFeePaidReport();
  }, [
    reportType,
    selectedCourse,
    selectedYear,
    selectedClass,
    selectedSection
  ]);
  // LOAD FEE PAID STUDENTS
  const loadFeePaidReport = async () => {
    setFeePaidLoading(true);
    try {
      const response =
        await axios.get(
          `${BASE_URL}/api/fee-paid-report`,
          {
            params: {
              courseID: selectedCourse,
              academicYearID: selectedYear,
              classID: selectedClass,
              sectionID:
                selectedSection || ""
            }
          }
        );
      setFeePaidStudents(
        response.data || []
      );
      setFeePaidPage(0);
    } catch (error) {
      console.error(
        "Error loading fee paid report:",
        error
      );
      setFeePaidStudents([]);
    } finally {
      setFeePaidLoading(false);

    }
  };
  // SEARCH
  const filteredFeePaidStudents =
    feePaidStudents.filter((student) => {
      const search =
        feePaidSearch
          .toLowerCase()
          .trim();
      if (!search) {
        return true;
      }
      return (
        String(
          student.StudentName || ""
        )
          .toLowerCase()
          .includes(search) ||
        String(
          student.ParentName || ""
        )
          .toLowerCase()
          .includes(search) ||
        String(
          student.RollNumber || ""
        )
          .toLowerCase()
          .includes(search) ||

        String(
          student.SectionName || ""
        )
          .toLowerCase()
          .includes(search)
      );
    });
  // STUDENT NAME CLICK
  const handleStudentClick = async (student) => {
    setSelectedStudent(student);
    setHistoryDialogOpen(true);
    setStudentHistory([]);
    setStudentHistoryLoading(true);
    try {
      const response =
        await axios.get(
          `${BASE_URL}/api/fee-paid-history/${student.StudentID}`,
          {
            params: {
              courseID: selectedCourse,
              academicYearID: selectedYear,
              classID: selectedClass
            }
          }
        );
      setStudentHistory(
        response.data || []
      );
    } catch (error) {
      console.error(
        "Error loading student fee history:",
        error
      );
      setStudentHistory([]);

    } finally {
      setStudentHistoryLoading(false);
    }
  };
  // CLOSE HISTORY
  const handleCloseHistory = () => {

    setHistoryDialogOpen(false);

    setSelectedStudent(null);

    setStudentHistory([]);

  };

  // =========================================================
  // EXPORT EXISTING REPORTS
  // =========================================================

  const handleExport = async () => {

    if (
      !reportType ||
      !selectedCourse ||
      !selectedYear
    ) {

      alert(
        "Please select required fields"
      );

      return;

    }

    if (
      reportType === "ByClass" &&
      !selectedClass
    ) {

      alert(
        "Please select Class"
      );

      return;

    }
 if (
    reportType === "FeePaid" &&
    !selectedClass
  ) {
    alert(
      "Please select Class"
    );
    return;
  }
    try {

      const response =
        await axios.post(
          `${BASE_URL}/api/export-excel`,
          {
            reportType,

            courseID:
              selectedCourse,

            academicYearID:
              selectedYear,

            classID:
              selectedClass || null,
             sectionID: selectedSection || null,

            categoryID:
              selectedCategory || null
              
          },
          {
            responseType: "blob"
          }
        );

      const blob =
        new Blob(
          [response.data],
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

      saveAs(
        blob,
        "Fee_Report.xlsx"
      );

    } catch (error) {

      console.error(
        "Error exporting report:",
        error
      );

      alert(
        "Unable to export report"
      );

    }

  };

  // =========================================================
  // EXPORT FEE BETWEEN DATE
  // =========================================================

  const handleExportt = async () => {

    if (
      !startDate ||
      !endDate ||
      !selectedCourse ||
      !selectedYear
    ) {

      alert(
        "Please select Course, AcademicYear with start and end dates."
      );

      return;

    }

    try {

      const response =
        await axios.post(
          `${BASE_URL}/api/export-fee-between-date`,
          {
            reportType,

            startDate,

            endDate,

            courseID:
              selectedCourse,

            academicYearID:
              selectedYear,

            classID:
              selectedClass ||
              undefined
          },
          {
            responseType: "blob"
          }
        );

      const blob =
        new Blob(
          [response.data],
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

      saveAs(
        blob,
        "Fee_Report.xlsx"
      );

    } catch (error) {

      console.error(
        "Error exporting report:",
        error
      );

    }

  };

  // =========================================================
  // EXPORT CONCESSION
  // =========================================================

  const handleExportConcession = async () => {

    try {

      const response =
        await axios.post(
          `${BASE_URL}/api/export-concession-report`,
          {
            courseID:
              selectedCourse || null,

            academicYearID:
              selectedYear || null,

            classID:
              selectedClass || null,

            startDate:
              startDate || null,

            endDate:
              endDate || null
          },
          {
            responseType: "blob"
          }
        );

      const blob =
        new Blob(
          [response.data],
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

      saveAs(
        blob,
        "Concession_Report.xlsx"
      );

    } catch (error) {

      console.error(
        "Error exporting concession report:",
        error
      );

    }

  };

  // =========================================================
  // FEE PAID EXPORT
  // =========================================================

  const handleExportFeePaid = async () => {

    if (
      !selectedCourse ||
      !selectedYear ||
      !selectedClass
    ) {

      alert(
        "Please select Course, Academic Year and Class."
      );

      return;

    }

    try {

      const response =
        await axios.post(
          `${BASE_URL}/api/export-excel`,
          {
            reportType: "FeePaid",

            courseID:
              selectedCourse,

            academicYearID:
              selectedYear,

            classID:
              selectedClass,

            sectionID:
              selectedSection ||
              null,

            footerConfig: {
              trust:
                footerConfig?.trust || "",

              schoolName:
                footerConfig?.brandName || "",

              address:
                footerConfig?.address || ""
            }
          },
          {
            responseType: "blob"
          }
        );

      const blob =
        new Blob(
          [response.data],
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

      saveAs(
        blob,
        "Student_Fee_Paid_History.xlsx"
      );

    } catch (error) {

      console.error(
        "Error exporting Fee Paid report:",
        error
      );

      alert(
        "Unable to export Fee Paid report"
      );

    }

  };

  // =========================================================
  // FORMAT MONEY
  // =========================================================

  const money = (value) => {

    return Number(
      value || 0
    ).toFixed(2);

  };

  // =========================================================
  // RENDER
  // =========================================================

  return (

    <Container
      maxWidth="xl"
      style={{
        paddingTop: "20px",
        paddingBottom: "40px"
      }}
    >

      <Typography
        variant="h4"
        style={{
          fontWeight: "700",
          marginBottom: "20px"
        }}
      >
        Fee Report
      </Typography>

      {/* =====================================================
          REPORT TYPE
      ===================================================== */}

      <FormControl
        fullWidth
        margin="normal"
      >

        <InputLabel>
          Report Type
        </InputLabel>

        <Select
          value={reportType}
          label="Report Type"
          onChange={(e) =>
            handleReportTypeChange(
              e.target.value
            )
          }
        >

          <MenuItem value="CategoryWise">
            Category Wise
          </MenuItem>

          <MenuItem value="ByClass">
            By Class
          </MenuItem>

          <MenuItem value="AllClass">
            All Class
          </MenuItem>

          <MenuItem value="FeeBetweenDate">
            Fee Between Dates
          </MenuItem>

          <MenuItem value="ConcessionReport">
            Concession Report
          </MenuItem>

          <MenuItem value="FeePaid">
            Fee Paid History
          </MenuItem>

        </Select>

      </FormControl>

      {/* =====================================================
          CONCESSION REPORT
      ===================================================== */}

      {reportType === "ConcessionReport" && (
        <>

          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Course (Optional)
            </InputLabel>

            <Select
              value={selectedCourse}
              label="Course (Optional)"
              onChange={(e) =>
                handleCourseChange(
                  e.target.value
                )
              }
            >

              {courses.map((course) => (

                <MenuItem
                  key={course.CourseID}
                  value={course.CourseID}
                >
                  {course.CourseName}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Academic Year (Optional)
            </InputLabel>

            <Select
              value={selectedYear}
              label="Academic Year (Optional)"
              onChange={(e) =>
                setSelectedYear(
                  e.target.value
                )
              }
            >

              {academicYears.map((year) => (

                <MenuItem
                  key={year.id}
                  value={year.id}
                >
                  {year.name}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Class (Optional)
            </InputLabel>

            <Select
              value={selectedClass}
              label="Class (Optional)"
              onChange={(e) =>
                handleClassChange(
                  e.target.value
                )
              }
            >

              {classes.map((cls) => (

                <MenuItem
                  key={cls.id}
                  value={cls.id}
                >
                  {cls.name}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

          <TextField
            fullWidth
            margin="normal"
            label="Start Date (Optional)"
            type="date"
            InputLabelProps={{
              shrink: true
            }}
            value={startDate}
            onChange={(e) =>
              setStartDate(
                e.target.value
              )
            }
          />

          <TextField
            fullWidth
            margin="normal"
            label="End Date (Optional)"
            type="date"
            InputLabelProps={{
              shrink: true
            }}
            value={endDate}
            onChange={(e) =>
              setEndDate(
                e.target.value
              )
            }
          />

          <Button
            variant="contained"
            onClick={
              handleExportConcession
            }
            style={{
              marginTop: "20px"
            }}
          >
            Export Concession Report
          </Button>

        </>
      )}

      {/* =====================================================
          FEE PAID REPORT
      ===================================================== */}

      {reportType === "FeePaid" && (
        <>

          {/* COURSE */}

          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Course
            </InputLabel>

            <Select
              value={selectedCourse}
              label="Course"
              onChange={(e) =>
                handleCourseChange(
                  e.target.value
                )
              }
            >

              {courses.map((course) => (

                <MenuItem
                  key={course.CourseID}
                  value={course.CourseID}
                >
                  {course.CourseName}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

          {/* ACADEMIC YEAR */}

          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Academic Year
            </InputLabel>

            <Select
              value={selectedYear}
              label="Academic Year"
              onChange={(e) =>
                setSelectedYear(
                  e.target.value
                )
              }
            >

              {academicYears.map((year) => (

                <MenuItem
                  key={year.id}
                  value={year.id}
                >
                  {year.name}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

          {/* CLASS */}

          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Class
            </InputLabel>

            <Select
              value={selectedClass}
              label="Class"
              onChange={(e) =>
                handleClassChange(
                  e.target.value
                )
              }
            >

              {classes.map((cls) => (

                <MenuItem
                  key={cls.id}
                  value={cls.id}
                >
                  {cls.name}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

          {/* SECTION
              Only displayed if this class has sections.
          */}

          {sections.length > 0 && (

            <FormControl
              fullWidth
              margin="normal"
            >

              <InputLabel>
                Section (Optional)
              </InputLabel>

              <Select
                value={selectedSection}
                label="Section (Optional)"
                onChange={(e) =>
                  setSelectedSection(
                    e.target.value
                  )
                }
              >

                <MenuItem value="">
                  All Sections
                </MenuItem>

                {sections.map((section) => (

                  <MenuItem
                    key={section.SectionID}
                    value={
                      section.SectionID
                    }
                  >
                    {section.SectionName}
                  </MenuItem>

                ))}

              </Select>

            </FormControl>

          )}

          {/* SEARCH */}

          {selectedCourse &&
            selectedYear &&
            selectedClass && (

              <Paper
                elevation={3}
                style={{
                  marginTop: "25px",
                  padding: "15px",
                  borderRadius: "12px"
                }}
              >

                <Box
                  style={{
                    display: "flex",
                    justifyContent:
                      "space-between",
                    alignItems: "center",
                    gap: "15px",
                    flexWrap: "wrap"
                  }}
                >

                  <TextField
                    label="Search Student / Parent / Roll Number"
                    value={
                      feePaidSearch
                    }
                    onChange={(e) => {

                      setFeePaidSearch(
                        e.target.value
                      );

                      setFeePaidPage(0);

                    }}
                    size="small"
                    style={{
                      minWidth: "280px",
                      flex: 1
                    }}
                  />

                  <Chip
                    label={`Students: ${filteredFeePaidStudents.length}`}
                    color="primary"
                  />

                  <Button
                    variant="contained"
                    onClick={
                      handleExportFeePaid
                    }
                  >
                    Export Fee Paid History
                  </Button>

                </Box>

              </Paper>

            )}

          {/* LOADING */}

          {feePaidLoading && (

            <Box
              style={{
                display: "flex",
                justifyContent:
                  "center",
                padding: "40px"
              }}
            >

              <CircularProgress />

            </Box>

          )}

          {/* TABLE */}

          {!feePaidLoading &&
            selectedCourse &&
            selectedYear &&
            selectedClass && (

              <Paper
                elevation={4}
                style={{
                  marginTop: "20px",
                  borderRadius: "12px",
                  overflow: "hidden"
                }}
              >

                <TableContainer
                  style={{
                    maxHeight: "650px",
                    overflowX: "auto"
                  }}
                >

                  <Table
                    stickyHeader
                    size="small"
                  >

                    <TableHead>

                      <TableRow>

                        <TableCell
                          style={{
                            background:
                              "#263238",
                            color: "#fff",
                            fontWeight: "700",
                            whiteSpace:
                              "nowrap"
                          }}
                        >
                          #
                        </TableCell>

                        <TableCell
                          style={{
                            background:
                              "#263238",
                            color: "#fff",
                            fontWeight: "700",
                            whiteSpace:
                              "nowrap"
                          }}
                        >
                          Student Name
                        </TableCell>

                        <TableCell
                          style={{
                            background:
                              "#263238",
                            color: "#fff",
                            fontWeight: "700",
                            whiteSpace:
                              "nowrap"
                          }}
                        >
                          Parent Name
                        </TableCell>

                        <TableCell
                          style={{
                            background:
                              "#263238",
                            color: "#fff",
                            fontWeight: "700",
                            whiteSpace:
                              "nowrap"
                          }}
                        >
                          Roll Number
                        </TableCell>

                        <TableCell
                          style={{
                            background:
                              "#263238",
                            color: "#fff",
                            fontWeight: "700",
                            whiteSpace:
                              "nowrap"
                          }}
                        >
                          Total Fee
                        </TableCell>

                        <TableCell
                          style={{
                            background:
                              "#263238",
                            color: "#fff",
                            fontWeight: "700",
                            whiteSpace:
                              "nowrap"
                          }}
                        >
                          Paid
                        </TableCell>

                        <TableCell
                          style={{
                            background:
                              "#263238",
                            color: "#fff",
                            fontWeight: "700",
                            whiteSpace:
                              "nowrap"
                          }}
                        >
                          Balance
                        </TableCell>

                      </TableRow>

                    </TableHead>

                    <TableBody>

                      {filteredFeePaidStudents
                        .slice(
                          feePaidPage *
                            feePaidRowsPerPage,

                          feePaidPage *
                            feePaidRowsPerPage +
                            feePaidRowsPerPage
                        )
                        .map(
                          (
                            student,
                            index
                          ) => (

                            <TableRow
                              key={
                                student.StudentID
                              }
                              hover
                            >

                              <TableCell>
                                {feePaidPage *
                                  feePaidRowsPerPage +
                                  index +
                                  1}
                              </TableCell>

                              <TableCell>

                                <Button
                                  variant="text"
                                  onClick={() =>
                                    handleStudentClick(
                                      student
                                    )
                                  }
                                  style={{
                                    textTransform:
                                      "none",
                                    fontWeight:
                                      "700",
                                    padding: 0
                                  }}
                                >
                                  {
                                    student.StudentName
                                  }
                                </Button>

                              </TableCell>

                              <TableCell>
                                {
                                  student.ParentName ||
                                  ""
                                }
                              </TableCell>

                              <TableCell>
                                {
                                  student.RollNumber ||
                                  ""
                                }
                              </TableCell>

                              <TableCell
                                align="right"
                              >
                                ₹{" "}
                                {money(
                                  student.TotalFee
                                )}
                              </TableCell>

                              <TableCell
                                align="right"
                              >
                                ₹{" "}
                                {money(
                                  student.Paid
                                )}
                              </TableCell>

                              <TableCell
                                align="right"
                                style={{
                                  fontWeight:
                                    "700",
                                  color:
                                    Number(
                                      student.Balance ||
                                        0
                                    ) > 0
                                      ? "#d32f2f"
                                      : "#2e7d32"
                                }}
                              >
                                ₹{" "}
                                {money(
                                  student.Balance
                                )}
                              </TableCell>

                            </TableRow>

                          )
                        )}

                      {filteredFeePaidStudents.length ===
                        0 && (

                        <TableRow>

                          <TableCell
                            colSpan={7}
                            align="center"
                            style={{
                              padding: "40px"
                            }}
                          >
                            No fee records found.
                          </TableCell>

                        </TableRow>

                      )}

                    </TableBody>

                  </Table>

                </TableContainer>

                <TablePagination
                  component="div"
                  count={
                    filteredFeePaidStudents.length
                  }
                  page={feePaidPage}
                  onPageChange={(
                    event,
                    newPage
                  ) =>
                    setFeePaidPage(
                      newPage
                    )
                  }
                  rowsPerPage={
                    feePaidRowsPerPage
                  }
                  onRowsPerPageChange={(
                    event
                  ) => {

                    setFeePaidRowsPerPage(
                      parseInt(
                        event.target.value,
                        10
                      )
                    );

                    setFeePaidPage(0);

                  }}
                  rowsPerPageOptions={[
                    100
                  ]}
                />

              </Paper>

            )}

        </>
      )}

      {/* =====================================================
          FEE BETWEEN DATE
      ===================================================== */}

      {reportType === "FeeBetweenDate" && (
        <>
          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Course
            </InputLabel>

            <Select
              value={selectedCourse}
              label="Course"
              onChange={(e) =>
                handleCourseChange(
                  e.target.value
                )
              }
            >

              {courses.map((course) => (

                <MenuItem
                  key={course.CourseID}
                  value={course.CourseID}
                >
                  {course.CourseName}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Academic Year
            </InputLabel>

            <Select
              value={selectedYear}
              label="Academic Year"
              onChange={(e) =>
                setSelectedYear(
                  e.target.value
                )
              }
            >

              {academicYears.map((year) => (

                <MenuItem
                  key={year.id}
                  value={year.id}
                >
                  {year.name}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Class (Optional)
            </InputLabel>

            <Select
              value={selectedClass}
              label="Class (Optional)"
              onChange={(e) =>
                handleClassChange(
                  e.target.value
                )
              }
            >

              {classes.map((cls) => (

                <MenuItem
                  key={cls.id}
                  value={cls.id}
                >
                  {cls.name}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

          <TextField
            fullWidth
            margin="normal"
            label="Start Date"
            type="date"
            InputLabelProps={{
              shrink: true
            }}
            value={startDate}
            onChange={(e) =>
              setStartDate(
                e.target.value
              )
            }
          />

          <TextField
            fullWidth
            margin="normal"
            label="End Date"
            type="date"
            InputLabelProps={{
              shrink: true
            }}
            value={endDate}
            onChange={(e) =>
              setEndDate(
                e.target.value
              )
            }
          />

          <Button
            variant="contained"
            onClick={
              handleExportt
            }
            style={{
              marginTop: "20px"
            }}
          >
            Export Fee Between Date
          </Button>

        </>
      )}

      {/* =====================================================
          OTHER REPORTS COURSE
      ===================================================== */}

      {reportType !== "FeeBetweenDate" &&
        reportType !== "ConcessionReport" &&
        reportType !== "FeePaid" && (

          <FormControl
            fullWidth
            margin="normal"
          >

            <InputLabel>
              Course
            </InputLabel>

            <Select
              value={selectedCourse}
              label="Course"
              onChange={(e) =>
                handleCourseChange(
                  e.target.value
                )
              }
            >

              {courses.map((course) => (

                <MenuItem
                  key={course.CourseID}
                  value={course.CourseID}
                >
                  {course.CourseName}
                </MenuItem>

              ))}

            </Select>

          </FormControl>

        )}

      {/* =====================================================
          OTHER REPORTS YEAR
      ===================================================== */}

      {(
        reportType === "ByClass" ||
        reportType === "AllClass" ||
        reportType === "CategoryWise"
      ) && (

        <FormControl
          fullWidth
          margin="normal"
        >

          <InputLabel>
            Academic Year
          </InputLabel>

          <Select
            value={selectedYear}
            label="Academic Year"
            onChange={(e) =>
              setSelectedYear(
                e.target.value
              )
            }
          >

            {academicYears.map((year) => (

              <MenuItem
                key={year.id}
                value={year.id}
              >
                {year.name}
              </MenuItem>

            ))}

          </Select>

        </FormControl>

      )}

      {/* =====================================================
          OTHER REPORTS CLASS
      ===================================================== */}

      {(
        reportType === "ByClass" ||
        reportType === "CategoryWise"
      ) && (

        <FormControl
          fullWidth
          margin="normal"
        >

          <InputLabel>
            Class
          </InputLabel>

          <Select
            value={selectedClass}
            label="Class"
            onChange={(e) =>
              handleClassChange(
                e.target.value
              )
            }
          >

            {classes.map((cls) => (

              <MenuItem
                key={cls.id}
                value={cls.id}
              >
                {cls.name}
              </MenuItem>

            ))}

          </Select>

        </FormControl>

      )}

      {/* =====================================================
          CATEGORY
      ===================================================== */}

      {reportType === "CategoryWise" && (

        <FormControl
          fullWidth
          margin="normal"
        >

          <InputLabel>
            Category
          </InputLabel>

          <Select
            value={selectedCategory}
            label="Category"
            onChange={(e) =>
              setSelectedCategory(
                e.target.value
              )
            }
          >

            {categories.map((cat) => (

              <MenuItem
                key={cat.id}
                value={cat.id}
              >
                {cat.name}
              </MenuItem>

            ))}

          </Select>

        </FormControl>

      )}

      {/* =====================================================
          EXISTING EXPORT BUTTON
      ===================================================== */}

      {reportType !== "FeeBetweenDate" &&
        reportType !== "ConcessionReport" &&
        reportType !== "FeePaid" && (

          <Button
            variant="contained"
            onClick={handleExport}
            style={{
              marginTop: "20px"
            }}
          >
            Export to Excel
          </Button>

        )}

      {/* =====================================================
          STUDENT FEE HISTORY DIALOG
      ===================================================== */}

      <Dialog
        open={historyDialogOpen}
        onClose={
          handleCloseHistory
        }
        fullWidth
        maxWidth="md"
      >

        <DialogTitle
          style={{
            fontWeight: "700",
            background:
              "#263238",
            color: "#fff"
          }}
        >

          Student Fee Paid History

          <IconButton
            onClick={
              handleCloseHistory
            }
            style={{
              position:
                "absolute",
              right: 8,
              top: 8,
              color: "#fff"
            }}
          >
            <CloseIcon />
          </IconButton>

        </DialogTitle>

        <DialogContent
          style={{
            paddingTop: "25px"
          }}
        >

          {selectedStudent && (

            <Paper
              elevation={2}
              style={{
                padding: "15px",
                marginBottom: "20px",
                borderRadius:
                  "10px"
              }}
            >

              <Typography
                variant="h6"
                style={{
                  fontWeight:
                    "700"
                }}
              >
                {
                  selectedStudent.StudentName
                }
              </Typography>

              <Typography>
                Parent:{" "}
                {
                  selectedStudent.ParentName ||
                  ""
                }
              </Typography>

              <Typography>
                Roll Number:{" "}
                {
                  selectedStudent.RollNumber ||
                  ""
                }
              </Typography>

              <Typography>
                Total Fee: ₹{" "}
                {money(
                  selectedStudent.TotalFee
                )}
              </Typography>

              <Typography>
                Total Paid: ₹{" "}
                {money(
                  selectedStudent.Paid
                )}
              </Typography>

              <Typography
                style={{
                  fontWeight:
                    "700"
                }}
              >
                Balance: ₹{" "}
                {money(
                  selectedStudent.Balance
                )}
              </Typography>

            </Paper>

          )}

          {studentHistoryLoading && (

            <Box
              style={{
                display: "flex",
                justifyContent:
                  "center",
                padding: "30px"
              }}
            >
              <CircularProgress />
            </Box>

          )}

          {!studentHistoryLoading && (

            <TableContainer
              component={Paper}
              style={{
                maxHeight:
                  "450px",
                overflowX:
                  "auto"
              }}
            >

              <Table
                stickyHeader
                size="small"
              >

                <TableHead>

                  <TableRow>

                    <TableCell
                      style={{
                        fontWeight:
                          "700"
                      }}
                    >
                      Date
                    </TableCell>

                    <TableCell
                      style={{
                        fontWeight:
                          "700"
                      }}
                    >
                      Receipt No
                    </TableCell>

                    <TableCell
                      style={{
                        fontWeight:
                          "700"
                      }}
                    >
                      Category
                    </TableCell>

                    <TableCell
                      align="right"
                      style={{
                        fontWeight:
                          "700"
                      }}
                    >
                      Paid
                    </TableCell>

                  </TableRow>

                </TableHead>

                <TableBody>

                  {studentHistory.map(
                    (history) => (

                      <TableRow
                        key={
                          history.FeeDetailID
                        }
                        hover
                      >

                        <TableCell>
                          {
                            history.PaymentDate
                          }
                        </TableCell>

                        <TableCell>
                          {
                            history.ReceiptID
                          }
                        </TableCell>

                        <TableCell>
                          {
                            history.CategoryName
                          }
                        </TableCell>

                        <TableCell
                          align="right"
                        >
                          ₹{" "}
                          {money(
                            history.Paid
                          )}
                        </TableCell>

                      </TableRow>

                    )
                  )}

                  {studentHistory.length ===
                    0 && (

                    <TableRow>

                      <TableCell
                        colSpan={4}
                        align="center"
                      >
                        No payment history found.
                      </TableCell>

                    </TableRow>

                  )}

                </TableBody>

              </Table>

            </TableContainer>

          )}

        </DialogContent>

      </Dialog>

    </Container>

  );
};

export default FeeReportPage;